module.exports = __webpack_public_path__ + "img/email.dd7eba76.png";